import { render } from "./NuevaDeclaracionMedicamento.vue?vue&type=template&id=aeeffb1c"
import script from "./NuevaDeclaracionMedicamento.vue?vue&type=script&lang=js"
export * from "./NuevaDeclaracionMedicamento.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__